import React from "react";

function Div4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="330"
      height="157"
      fill="none"
      viewBox="0 0 330 157"
    >
      <path
        stroke="#61FF00"
        strokeWidth="0.802"
        d="M328.815 127.448l-38.466 28.685H174.926M1 35.882L32.627.64h166.745"
      ></path>
    </svg>
  );
}

export default Div4;
